<script setup lang="ts">
import { computed, provide, toRaw, toValue, useTemplateRef, watch, watchEffect } from 'vue';
import TextInput from './commons/TextInput.vue';
import DateInput from './commons/DateInput.vue';
import SelectInput from './commons/SelectInput.vue';
import useBillingAddress from '../composables/useBillingAddress';
import useCheckout from '../composables/useCheckout';
import {i18n} from "@/libs/wordpress.facade";

const {step, wooCart} = useCheckout();

const billingData = useBillingAddress();
const {form, canEdit} = billingData;
const {controllers} = form;

const formElRef = useTemplateRef('form-container');

function goNext(){
	if(!wooCart.showShippingMethodStep.value){
		if(!wooCart.showShippingAddressStep.value) step.value += 3;
		else step.value += 2;
	}else step.value++;
}

function scrollTo(element: HTMLElement|null){
	if(!element) return;
	window.scrollTo({behavior: 'smooth', top: element.getBoundingClientRect().top + window.pageYOffset - 50});
	//element.scrollIntoView({behavior: 'smooth'});
}

function confirm(){
	if(!canEdit.value){
		goNext();
		return;
	}
	if(!form.validate()){
		scrollTo(formElRef.value);
		return;
	}
	const prevDisabled = form.disabled.value;
	form.disabled.value = true;
	wooCart.updateCustomer({
		billing_address: form.getApiFormData()
	}).then((error) => {
		wooCart.refreshCart();
		if(!error){
			goNext();
		}
	})
	.then(() => {
		form.disabled.value = prevDisabled;
	});
}

function back(){
	step.value--;
}

</script>

<template lang="pug">
.itlp-checkout-billing-data-form-content(ref='form-container')
	.itlp-checkout-billing-data-form-title {{i18n.__('Dati personali', 'italpreziosi')}}
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["firstname"]' :controller="controllers['firstname']")
		text-input(v-if='controllers["lastname"]' :controller="controllers['lastname']")
	.itlp-checkout-billing-data-form-row
		text-input.itlp-checkout-billing-data-form-row-item-full(v-if='controllers["address"]' :controller="controllers['address']")
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["city"]' :controller="controllers['city']")
		text-input(v-if='controllers["province"] && controllers["province"].inputType.value == "text"' :controller="controllers['province']")
		select-input(v-if='controllers["province"] && controllers["province"].inputType.value == "select"' :controller="controllers['province']")
		div(v-if='controllers["province"] && controllers["province"].inputType.value == "hidden"')
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["postcode"]' :controller="controllers['postcode']")
		select-input(v-if='controllers["country"]' :controller="controllers['country']")
	.itlp-checkout-billing-data-form-row
		date-input(v-if='controllers["birthday"]' :controller="controllers['birthday']")
		text-input(v-if='controllers["birthplace"]' :controller="controllers['birthplace']")
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["phone"]' :controller="controllers['phone']")
		text-input(v-if='controllers["fiscalcode"]' :controller="controllers['fiscalcode']")
	.itlp-checkout-billing-data-form-row
		select-input(v-if='controllers["account_type"]' :controller="controllers['account_type']")
		div
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["company"]' :controller="controllers['company']")
		text-input(v-if='controllers["company_registration_number"]' :controller="controllers['company_registration_number']")
	.itlp-checkout-billing-data-form-row
		date-input(v-if='controllers["date_of_establishment"]' :controller="controllers['date_of_establishment']")
		text-input(v-if='controllers["registered_office"]' :controller="controllers['registered_office']")
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["vat_id"]' :controller="controllers['vat_id']")
	.itlp-checkout-billing-data-form-row
		text-input(v-if='controllers["sdi"]' :controller="controllers['sdi']")
		text-input(v-if='controllers["pec"]' :controller="controllers['pec']")
	.itlp-checkout-billing-data-form-title {{i18n.__('Documento', 'italpreziosi')}}
	.itlp-checkout-billing-data-form-row
		select-input(v-if='controllers["document_type"]' :controller="controllers['document_type']")
		text-input(v-if='controllers["document_code"]' :controller="controllers['document_code']")
	.itlp-checkout-billing-data-form-row
		date-input(v-if='controllers["document_expiration_date"]' :controller="controllers['document_expiration_date']")
		div
.itlp-checkout-billing-data-form-footer
	button(v-if='!wooCart.hasStonexShipping.value' @click='back()') {{i18n.__('Modifica modalità di gestione', 'italpreziosi')}}
	button(@click='confirm()' :disabled='Boolean(wooCart.requesting.value)') {{i18n.__('Conferma', 'italpreziosi')}}
</template>

<style>
.itlp-checkout-billing-data-form-content{
	flex: 1;
}
.itlp-checkout-billing-data-form-title{
	margin-top: 12px;
}
.itlp-checkout-billing-data-form-row{
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 30px;
	margin-top: 8px;
}
.itlp-checkout-billing-data-form-row > div{
	flex: 0.5;
}

.itlp-checkout-billing-data-form-row > .itlp-checkout-billing-data-form-row-item-full{
	flex: 1;
}
</style>